export default function normalizeNestedProperty(nestedProperty) {
  if (nestedProperty.charAt(0) === '&') {
    return nestedProperty.slice(1);
  }

  return nestedProperty;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/normalizeNestedProperty.js
// module id = 872
// module chunks = 0